"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTransitionGroup = require("react-transition-group");

var _debounce = require("debounce");

var _debounce2 = _interopRequireDefault(_debounce);

var _reactIntl = require("react-intl");

require("./global.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var transitionStyle = function transitionStyle(transitionTime) {
  return {
    transition: "".concat(transitionTime, "ms ease-in-out")
  };
};

var GradientCollapse = /*#__PURE__*/function (_Component) {
  _inherits(GradientCollapse, _Component);

  function GradientCollapse(props) {
    var _this;

    _classCallCheck(this, GradientCollapse);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GradientCollapse).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "calcMaxHeight", function () {
      var collapseHeight = _this.props.collapseHeight;
      var wrapper = _this.wrapper.current;

      if (wrapper.scrollHeight > collapseHeight) {
        var maxHeight = wrapper.scrollHeight + 60;

        _this.setState({
          isCollapseVisible: true,
          maxHeight: maxHeight
        });
      } else _this.setState({
        isCollapseVisible: false,
        maxHeight: 'auto'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "debouncedCalcMaxHeight", (0, _debounce2["default"])(_this.calcMaxHeight, 500));

    _this.state = {
      isCollapseVisible: true,
      collapsed: true,
      maxHeight: 'auto'
    };
    _this.wrapper = _react2["default"].createRef();
    return _this;
  }

  _createClass(GradientCollapse, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.debouncedCalcMaxHeight);
      this.calcMaxHeight();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.debouncedCalcMaxHeight);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          collapseHeight = _this$props.collapseHeight;
      var _this$state = this.state,
          collapsed = _this$state.collapsed,
          isCollapseVisible = _this$state.isCollapseVisible,
          maxHeight = _this$state.maxHeight;
      var height = isCollapseVisible && collapsed ? collapseHeight : maxHeight;
      var transitionTime = 600;
      var fadeOutTime = 400;
      return _react2["default"].createElement(_reactTransitionGroup.Transition, {
        timeout: transitionTime,
        "in": !collapsed
      }, function (state) {
        return _react2["default"].createElement("div", {
          style: _objectSpread({}, transitionStyle(transitionTime), {
            height: height,
            overflow: 'hidden'
          }),
          className: "relative"
        }, _react2["default"].createElement("div", {
          ref: _this2.wrapper,
          className: "h-auto"
        }, children), _react2["default"].createElement("div", {
          className: "".concat(isCollapseVisible ? 'flex' : 'dn', " absolute bottom-0 pointer-events-none w-100 h-100 flex-column justify-end")
        }, _react2["default"].createElement("div", {
          style: transitionStyle(fadeOutTime),
          className: "".concat(state === 'entered' ? 'o-0' : '', " fade-bottom w-100 h-50")
        }), _react2["default"].createElement("div", {
          className: "".concat(state === 'entered' ? 'bg-transparent' : 'bg-base', " tc w-100 pointer-events-auto")
        }, _react2["default"].createElement("div", {
          className: "c-action-primary t-action pointer ma5",
          onClick: function onClick() {
            return _this2.setState({
              collapsed: !collapsed
            });
          }
        }, state === 'entered' || collapsed && state !== 'exited' ? _react2["default"].createElement(_reactIntl.FormattedMessage, {
          id: "collapse.showLess"
        }) : _react2["default"].createElement(_reactIntl.FormattedMessage, {
          id: "collapse.showMore"
        })))));
      });
    }
  }]);

  return GradientCollapse;
}(_react.Component);

GradientCollapse.propTypes = {
  /** Maximum height collapsed */
  collapseHeight: _propTypes2["default"].number.isRequired,
  children: _propTypes2["default"].node
};
exports["default"] = GradientCollapse;